/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pagination_NextInputs */

const cs_pagination_next = /** @type {(inputs: Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další stránka`)
};

const en_pagination_next = /** @type {(inputs: Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next page`)
};

/**
* | output |
* | --- |
* | "Next page" |
*
* @param {Pagination_NextInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pagination_next = /** @type {((inputs?: Pagination_NextInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pagination_NextInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pagination_next(inputs)
	return cs_pagination_next(inputs)
});